export enum InventoryFileType {
    GeneralSupportingFile = 0,
    QuestionnaireFile = 1,
    MetadataPageFile = 2,
    PhotoFile = 3,
    DeclareFile = 4,
    MsdsFile = 5,
    ComplianceGeneralFile = 6,
    ScipFile = 7,
    SustainabilityFile = 8,
    CircularityFile = 9,
    GeneralSupportingFileHpd = 10,
    GeneralSupportingFileC2c = 11,
    GeneralSupportingFileVoc = 12,
    GeneralSupportingFileOther = 13,
    HniEdsImageFile = 14,
    SoldItemFile = 15,
    DynamicRegulationPageFile = 16,
    TdsFile = 17,
    VocDataFile = 18,
    InstructionsFile = 19
}

export enum FieldType {
    FieldGroup = "FieldGroup",
    TextInput = "TextInput",
    TextArea = "TextArea",
    SingleSelectInput = "SingleSelectInput", //Dropdown
    MultiSelectInput = "MultiSelectInput", //Checkbox
    RadioButtons = "RadioButtons",
    MultipleFiles = "MultipleFiles",
    SelectCertification = "SelectCertification",
    MultipleTextInputRows = "MultipleTextInputRows"
}

export interface Option {
    description: string;
    value: string;
}

export interface Field {
    type: FieldType;
    label: string;
    instructions: string;
    summaryDataTableKey?: string;
    inventoryFileType?: InventoryFileType;
    isExportable?: boolean;
    enumType?: string;
    options?: Option[];
    childFields?: Field[];
}

export interface Section {
    title: string;
    questionnairePageType: string;
    fields: Field[];
}

export interface Page {
    title: string;
    questionnairePageType: string;
    sections: Section[];
}

export interface StandardSumaryDataFieldsConfig {
    pages: Page[];
}